import { ReactElement, useState } from 'react'
import { useFormikContext } from 'formik'
import { Button, Grid, P } from '@farewill/ui'

import CrematoriumPicker from 'components/form/crematorium-picker'
import { Crematorium as CrematoriumModel } from 'lib/models/crematorium'

import { FormikValues, SaveProp } from './types'

export type CrematoriumProps = {
  handleSave: SaveProp
  customerPostcode?: string | null
}

export const Crematorium = ({
  handleSave,
  customerPostcode,
}: CrematoriumProps): ReactElement => {
  const { values } = useFormikContext<FormikValues>()

  const [crematorium, setCrematorium] = useState(
    values.crematorium ?? undefined
  )
  const [showCrematoriumPicker, setShowCrematoriumPicker] =
    useState(!!crematorium)

  /** Show the change straight away, but put back what is actually saved if the
   * save fails - the failure itself is reported by the request status panel. */
  const saveCrematorium = async (updated?: CrematoriumModel) => {
    const previous = crematorium
    setCrematorium(updated)

    try {
      await handleSave({ name: 'crematoriumId', value: updated?.id ?? null })
    } catch {
      setCrematorium(previous)
    }
  }

  return (
    <Grid.Item>
      <Grid data-testid="choose-a-crematorium">
        {!showCrematoriumPicker && (
          <Grid.Item>
            <P>
              Would they like to choose where the cremation will take place?
            </P>
            <Button.Primary
              type="button"
              onClick={() => setShowCrematoriumPicker(true)}
            >
              Choose crematoria
            </Button.Primary>
          </Grid.Item>
        )}
        {showCrematoriumPicker && (
          <CrematoriumPicker
            crematorium={crematorium}
            customerPostcode={customerPostcode}
            onReset={() => saveCrematorium(undefined)}
            boldHeader={false}
            onCrematoriumChanged={saveCrematorium}
          />
        )}
      </Grid>
    </Grid.Item>
  )
}

export default Crematorium
